import { useStore } from 'effector-react'

import {
  $withdrawals,
  $totalCountOfWithdrawals,
  withdrawalsListMounted,
  getWithdrawals,
  $fastFilters,
  getFastFilters,
} from './model'
import { WithdrawalRequest } from './types'
import { useEffect } from 'react'

export const useWithdrawalsList = () => {
  const onChangeWithdrawalsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: WithdrawalRequest) => {
    withdrawalsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useStore(getWithdrawals.pending)

  const withdrawals = useStore($withdrawals)
  const totalCountOfWithdrawals = useStore($totalCountOfWithdrawals)
  return {
    withdrawals,
    totalCountOfWithdrawals,
    loading,
    onChangeWithdrawalsList,
  }
}

export const useFastFilters = () => {
  const fastFilters = useStore($fastFilters)
  const fastFiltersLoaded = useStore(getFastFilters.pending)

  useEffect(() => {
    getFastFilters({})
  }, [])

  return { fastFilters, fastFiltersLoaded }
}
